import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/** Id of the empty slot Layout renders just left of the notifications bell. */
export const HEADER_ELLIOTT_SLOT_ID = 'header-elliott-slot';

/**
 * Renders its children into the top bar, left of the notifications bell. Pages
 * own their Elliott orb (each opens its own menu), but it lives in the shared
 * header. Renders nothing until the slot exists.
 */
const HeaderElliottSlot: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setSlot(document.getElementById(HEADER_ELLIOTT_SLOT_ID));
  }, []);
  return slot ? createPortal(children, slot) : null;
};

export default HeaderElliottSlot;
